<h2 appDialogTitle>Aprovar atestado</h2>
<!--
  data-cs-mask: the message textarea may contain free-text written
  by the operator that references the employee. Masked in
  Contentsquare UXA recordings.
-->
<form [formGroup]="form" data-cs-mask>
  <div *ngIf="!!situationsDataSource?.length">
    <h4>Selecione a situação</h4>
    <app-form-situations
      formControlName="situations"
      [interval]="data.interval"
      [dataSource]="situationsDataSource"
      [required]="true"
      [multiples]="multipleAllowed$ | async"
    ></app-form-situations>
  </div>
  <div>
    <h4>Escrever uma mensagem ao funcionário?</h4>
    <div *ngIf="hasMoreThanOneMessage" class="pb-12">
      <app-autocomplete-form-reason
        formControlName="reason"
        type="approval"
      ></app-autocomplete-form-reason>
    </div>

    <div class="small-form-field w-100">
      <app-form-field class="w-100" appearance="outline">
        <app-label>(opcional) Mensagem ao funcionário</app-label>
        <app-input
          multiline
          [rows]="3"
          formControlName="message"
          [errorStateMatcher]="messageErrorMatcher"
        ></app-input>
        <app-hint *ngIf="messageLimit !== null" align="end">
          {{ message.value?.length || 0 }}/{{ messageLimit }}
        </app-hint>
        <app-error *ngIf="message.hasError('maxlength')">
          Máximo de {{ message.errors?.maxlength.requiredLength }} caracteres
          ({{ message.errors?.maxlength.actualLength }}/{{
            message.errors?.maxlength.requiredLength
          }})
        </app-error>
      </app-form-field>
    </div>
  </div>
</form>
<div appDialogActions align="end">
  <app-button variant="ghost-primary" (click)="onNoClicked()">
    CANCELAR
  </app-button>
  <app-button
    variant="ghost-primary"
    [disabled]="approveDisabled"
    (click)="onOkClick()"
  >
    APROVAR
  </app-button>
</div>
